export const ACCOUNT_UPDATE = 'ACCOUNT_UPDATE'
export const ACCOUNT_UPDATE_SUBMIT = 'ACCOUNT_UPDATE_SUBMIT'
export const ACCOUNT_UPDATE_FAILURE = 'ACCOUNT_UPDATE_FAILURE'
